import { ref, onMounted, onUnmounted } from 'vue'

/**
 * Same functionality as the `useMounted` composable of `@vueuse/core`
 * but it will set the value to false when the component is unmounted again
 */
export function useMounted() {
  const isMounted = ref(false)

  onMounted(() => {
    isMounted.value = true
  })

  onUnmounted(() => {
    isMounted.value = false
  })

  return isMounted
}
